// *******************************************************************************
// Mobile menu toggle
// *******************************************************************************

attachEvent('.hamburger', 'click', (ev) => {
  ev.preventDefault();
  document.documentElement.classList.toggle('is-open-menu');
  if (landingSlider.autoplay.running) {
    landingSlider.autoplay.stop();
  } else {
    landingSlider.autoplay.start();
  }
});

attachEvent('.menu__overlay', 'click', (ev) => {
  document.documentElement.classList.remove('is-open-menu');
  ev.preventDefault();
  if (landingSlider) {
    landingSlider.autoplay.start();
  }
  // toggleScroll();
});

// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 20);
}

let lastScrollTop = 0;
window.addEventListener(
  'scroll',
  () => {
    const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
    lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
  },
  false,
);

// Debounce the function to prevent multiple executions on scroll event
const debounceScroll = debounce(() => {
  addScrollingClass();
}, 50);

window.addEventListener('scroll', debounceScroll);
